module.exports = __webpack_public_path__ + "public/SiteIcons/viewProfileArrow.svg?b0669673";